
import Vue from 'vue';
import { UserModel } from '@descomplica/dex-models';
import { Icon } from '@descomplica/vue-components';
import { UnifiedCommentModel } from '@/models/UnifiedCommentModel';

export default Vue.extend({
  components: {
    Icon,
  },
  props: {
    comment: {
      type: Object as Vue.PropType<UnifiedCommentModel>,
      required: true,
    },
    user: {
      type: Object as Vue.PropType<UserModel>,
      required: true,
    },
    isUpdating: {
      type: Boolean,
      default: false,
    },
    isPastDue: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isValidScore(): boolean {
      return this.comment.score !== null && this.comment.score >= 0;
    },
    hasStudentComment(): boolean {
      return this.comment.text !== null;
    },
  },
});
